module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'simple') ? _c('ul', {
    staticClass: "ts-pagination",
    class: {
      'is-simple': _vm.type === 'simple'
    }
  }, [(_vm.detail) ? _c('a', {
    class: {
      'is-disabled': _vm.currentPage < 1
    },
    on: {
      "click": function($event) {
        _vm.goto(1)
      }
    }
  }, [_vm._v("首页")]) : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage != 1 || !_vm.detail),
      expression: "currentPage != 1||!detail"
    }],
    class: {
      'is-disabled': _vm.currentPage < 1
    },
    on: {
      "click": function($event) {
        _vm.currentPage-- && _vm.goto(_vm.currentPage--)
      }
    }
  }, [_vm._v("上一页")]), _vm._v(" "), (_vm.detail) ? _c('strong', [_c('i', [_vm._v(_vm._s(_vm.currentPage))]), _vm._v("/" + _vm._s(_vm.total))]) : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.total != _vm.currentPage && _vm.total != 0) || !_vm.detail),
      expression: "(total != currentPage && total != 0 )||!detail"
    }],
    class: {
      'is-disabled': _vm.currentPage < 1
    },
    on: {
      "click": function($event) {
        _vm.currentPage++ && _vm.goto(_vm.currentPage++)
      }
    }
  }, [_vm._v("下一页")]), _vm._v(" "), (_vm.detail) ? _c('a', {
    staticClass: "ts-pagination--end",
    class: {
      'is-disabled': _vm.currentPage === _vm.total || _vm.currentPage < 1
    },
    on: {
      "click": function($event) {
        _vm.goto(_vm.total)
      }
    }
  }, [_vm._v("尾页")]) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      'is-disabled': _vm.total <= 0
    }
  }, [_vm._v("\r\n    每页显示\r\n      "), _c('ts-select', {
    staticClass: "ts-pagination--select",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.total <= 0,
      "options": _vm.showItems
    },
    on: {
      "change": function($event) {
        _vm.handleChangeItem(_vm.item)
      }
    },
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  }), _vm._v("\r\n    条\r\n  ")], 1)]) : _c('ul', {
    staticClass: "ts-pagination"
  }, [_c('li', {
    staticClass: "ts-pagination-prev",
    class: {
      'is-disabled': _vm.currentPage === 1
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('a', [_c('span', [_vm._v("<<")])])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.changePage(1)
      }
    }
  }, [_c('a', [_vm._v("1")])]), _vm._v(" "), (_vm.currentPage - 3 > 1) ? _c('li', {
    staticClass: "ts-pagination--jump-prev",
    on: {
      "click": _vm.fastPrev
    }
  }, [_c('a', [_c('span', [_vm._v("<<")])])]) : _vm._e(), _vm._v(" "), (_vm.currentPage - 2 > 1) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage - 2)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage - 2))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage - 1 > 1) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage - 1)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage - 1))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage != 1 && _vm.currentPage != _vm.allPages) ? _c('li', {
    staticClass: "ts-pagination active"
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage + 1 < _vm.allPages) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage + 1)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage + 1))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage + 2 < _vm.allPages) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage + 2)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage + 2))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage + 3 < _vm.allPages) ? _c('li', {
    staticClass: "ts-pagination--jump-next",
    on: {
      "click": _vm.fastNext
    }
  }, [_c('a', [_c('span', [_vm._v(">>")])])]) : _vm._e(), _vm._v(" "), (_vm.allPages > 1) ? _c('li', {
    class: {
      'is-active': _vm.currentPage === _vm.allPages
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.allPages)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.allPages))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "ts-pagination-next",
    class: {
      'is-disabled': _vm.currentPage === _vm.allPages
    },
    on: {
      "click": _vm.next
    }
  }, [_c('a', [_c('span', [_vm._v(">>")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-291b7d2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsPagation.vue
// module id = 811
// module chunks = 39